<template>
  <div class="flex flex-col gap-4">
    <div class="card shadow-md bg-base-100 rounded-xl">
      <div class="card-body p-4 sm:p-5 flex flex-col gap-4">
        <div>
          <div class="flex items-center gap-1.5 mb-2">
            <span class="relative flex h-2 w-2 shrink-0">
              <span class="animate-ping [animation-duration:2s] absolute inline-flex h-full w-full rounded-full bg-success opacity-75"></span>
              <span class="relative inline-flex h-2 w-2 rounded-full bg-success"></span>
            </span>
            <span class="text-xs text-success font-semibold">Market Open</span>
          </div>
          <h1 class="text-2xl font-bold leading-tight">{{ competition.name }}</h1>
          <p class="text-xs text-base-content/45 mt-1.5 leading-relaxed">{{ competition.description }}</p>
          <progress
            class="progress progress-primary w-full h-1.5 mt-1.5"
            :value="competition.days_elapsed"
            :max="competition.duration_days"
          ></progress>
        </div>

        <div class="flex flex-col gap-2">
          <span class="text-[10px] font-bold text-base-content/35 uppercase tracking-widest">Rules</span>
          <div class="flex flex-wrap gap-1.5">
            <span class="badge badge-ghost gap-1 text-xs px-2">
              <i class="mdi mdi-trending-up text-sm"></i>
              {{ competition.direction }}
            </span>
            <span class="badge badge-ghost gap-1 text-xs px-2">
              <i class="mdi mdi-flag-outline text-sm"></i>
              {{ competition.universe }}
            </span>
            <span class="badge badge-ghost gap-1 text-xs px-2">
              <i class="mdi mdi-chart-pie-outline text-sm"></i>
              Max {{ competition.max_stocks }}
            </span>
            <span class="badge badge-ghost gap-1 text-xs px-2">
              <i class="mdi mdi-calendar-week-outline text-sm"></i>
              {{ Math.round(competition.duration_days / 7) }} weeks
            </span>
          </div>
        </div>

        <div class="border-t border-dashed border-base-content/15"></div>

        <div class="flex flex-col gap-2">
          <span class="text-[10px] font-bold text-base-content/35 uppercase tracking-widest">Status</span>
          <div class="flex flex-col gap-1.5">
            <div class="flex items-center justify-between text-sm">
              <span class="text-base-content/55">Day</span>
              <span class="font-semibold tabular-nums">{{ currentCompetitionDay }} / {{ competition.duration_days }}</span>
            </div>
            <div class="flex items-center justify-between text-sm">
              <span class="text-base-content/55">Last trading day</span>
              <span class="font-semibold text-right">{{ lastTradingDay }}</span>
            </div>
            <div class="flex items-center justify-between text-sm">
              <span class="text-base-content/55">Players</span>
              <span class="font-semibold tabular-nums">{{ competition.total_players }}</span>
            </div>
            <div class="flex items-center justify-between text-sm">
              <span class="text-base-content/55">Unique stocks</span>
              <span class="font-semibold tabular-nums">{{ universeStocksCount }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="card shadow-md bg-base-100 rounded-xl">
      <div class="card-body p-4 gap-3">
        <div class="flex items-center gap-2">
          <i class="mdi mdi-eye-outline text-base text-base-content/60"></i>
          <span class="text-sm font-semibold">Spectate only</span>
        </div>
        <p class="text-xs text-base-content/50 leading-relaxed">
          This competition has already started. You can follow along, but joining is no longer available.
        </p>
        <button class="btn btn-sm btn-outline w-full mt-1" disabled>
          View open competitions
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useCompetitionDates } from '../composables/useCompetitionDates.js'

const props = defineProps({
  competition: { type: Object, required: true },
  universeStocksCount: { type: Number, required: true },
})

const { currentCompetitionDay, lastTradingDay } = useCompetitionDates(props.competition)
</script>
